<div *ngIf="report">
      
    <div [style]="styles.header.page">
      <div [style]="styles.header.text"><b>YOUR STYLE COMBINATIONS</b></div>
  
      <div [style]="styles.header.line"></div>
    </div>
  
    <div [style]="styles.container_padding">
  
      <h2 [style]="styles.general_h2"><b>Interaction of Your Top Two Styles in Combination</b></h2>
          
      <p [style]="styles.paragraph">Your top two strengths are 
        <span [style]="styles.highlight">{{ report.primaryCoachingStyle }} </span> and 
        <span [style]="styles.highlight">{{ report.secondaryCoachingStyle }}</span>.</p>
  
      <p [style]="styles.paragraph" [innerHtml]="html"></p>
  
    </div>
  
  </div>